import React/*, { Component }*/ from 'react';
import PropTypes from 'prop-types';
//import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { Input/*, Switch*/ } from '@progress/kendo-react-inputs';

//import { isEmpty } from '../helpers';
import DropDownContainer from './DropDownContainer';
import isPage from '../hoc/isPage';
import { AppContext } from '../context/AppContext';

class PartLookupSearchBox extends React.Component {


    static propTypes = {
        onSearch: PropTypes.func,
        handleSearchParamsChange: PropTypes.func,
        searchParams: PropTypes.object

    }
    //constructor(props) {
    //    super(props);
    //}
    render() {
        const orgType = this.context.state.orgType;

        // check whether the user's org has a parent
        const hasParent = this.context.state.hasParent;

        //!DBTRANS! @m0466@ Filters !DEVNOTE! Input field label
        //!DBTRANS! @m0467@ Dealership !DEVNOTE! Input field label
        //!DBTRANS! @m0191@ Part Number !DEVNOTE! Input field label
        //!DBTRANS! @m0259@ Vendor !DEVNOTE! Input field label
        //!DBTRANS! @m0469@ Check other stores? !DEVNOTE!
        //!DBTRANS! @m0021@ Apply !DEVNOTE! Button Label

        return (
            <form className={`bottom-margin-60 search-panel shadow-box ${this.props.className}`}>

                <div className="search-controls-header">{this.props.returnLocalizedString("m0466")}</div>
                <div className="search-controls">
                    {(orgType === "dealergroup" || orgType === "manufacturer.region" || orgType === "manufacturer") && (
                        <fieldset className="right-margin-20">
                            <DropDownContainer dataType="dealerships" name="selectedDealership" label={this.props.returnLocalizedString("m0467")} defaultToFirstItem={true} hasEmptyOption={true}
                                uiLanguage={this.props.getLanguage()}
                                handleChange={this.props.handleSearchParamsChange} value={this.props.searchParams.selectedDealership} />
                        </fieldset>
                    )}
                    <fieldset className="right-margin-20">
                        <Input required={true} label={this.props.returnLocalizedString("m0191")} name="selectedPartNumber" type="text" onChange={this.props.handleSearchParamsChange} value={this.props.searchParams.selectedPartNumber} />
                    </fieldset>
                    {orgType === "dealergroup" && (
                        <fieldset className="right-margin-20">
                            <DropDownContainer dataType="vendors" name="selectedVendor" label={this.props.returnLocalizedString("m0038")} defaultToFirstItem={true}
                                uiLanguage={this.props.getLanguage()}
                                handleChange={this.props.handleSearchParamsChange} value={this.props.searchParams.selectedVendor} orgID={(this.props.searchParams.selectedDealership) ? this.props.searchParams.selectedDealership.orgID : undefined} />
                        </fieldset>
                    )}
                    {orgType === "dealer" && (
                        <fieldset className="right-margin-20">
                            <DropDownContainer dataType="vendors" name="selectedVendor" label={this.props.returnLocalizedString("m0038")} defaultToFirstItem={true}
                                uiLanguage={this.props.getLanguage()}
                                handleChange={this.props.handleSearchParamsChange} value={this.props.searchParams.selectedVendor} />
                        </fieldset>
                    )}
                </div>

                {hasParent && (orgType === "dealer" || orgType === "dealergroup") && (
                    <div className="top-margin-15">
                        <label className="padding-right-5" htmlFor="checkOtherStores">{this.props.returnLocalizedString("m0469")}</label>
                        <input type="checkbox" onChange={this.props.handleSearchParamsChange} name="checkOtherStores" id="checkOtherStores" />
                    </div>
                )}


                <div className="top-margin-15">
                    <Button primary={true} onClick={this.props.handleSearch}>{this.props.returnLocalizedString("m0021")}</Button>
                </div>


            </form>
        );
    }
}
export default isPage(PartLookupSearchBox);
PartLookupSearchBox.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/components/PartLookupSearchBox.js